import React, { useState } from 'react'
import cx from 'clsx';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as ExpandRowIcon } from '@assets/svg/executive-summary/ic-expand-row.svg';
import ActionItemsByEquipmentTable from '../ActionItemsByEquipmentTable/ActionItemsByEquipmentTable'

import { selectAppLocationSelectValue } from '@store/useAppStore';

import type { IAssetHealthEquipmentList } from '../../model/assetHealthEquipmentList';

import style from './style.module.scss';

interface IProps {
  row: IAssetHealthEquipmentList;
  key: React.Key;
}

const ExpandedRow: React.FC<IProps> = ({ row, key }) => {
  const [isVisibleHiddenRow, setVisibleHiddenRow] = useState(false);

  const locationSelectValue = selectAppLocationSelectValue();

  return (
    <>
      <tr key={key} className={style.bodyRow}>
        <td>
          <div
            className={style.ellipsisTextTwoLine}
            data-tooltip-content={row.location_name}
            data-tooltip-id="equipment-cell-tooltip"
          >
            {row.location_name}
          </div>
          {locationSelectValue.id === 'all' && (
            <div className={style.facilityName}>{row.facility_name}</div>
          )}
        </td>
        <td>
          <div
            className={style.equipmentNameColumn}
            data-tooltip-content={row.equipment_name}
            data-tooltip-id="equipment-cell-tooltip"
          >
            {row.equipment_name}
          </div>
        </td>
        <td>{row.critical_regular_ais_count}</td>
        <td>{row.high_regular_ais_count}</td>
        <td>{row.standard_regular_ais_count}</td>
        <td>{row.total_ais_count}</td>
        <td
          className={style.iconColumn}
          onClick={() => setVisibleHiddenRow((prev) => !prev)}
        >
          <ExpandRowIcon
            className={cx(style.expandRowIcon, { [style.expandRowIconTop]: isVisibleHiddenRow })}
          />
        </td>
      </tr>
      {isVisibleHiddenRow && (
        <tr>
          <ActionItemsByEquipmentTable
            equipmentId={row.equipment_id}
            total={row.total_ais_count}
            isVisibleHiddenRow={isVisibleHiddenRow}
          />
        </tr>
      )}
    </>
  )
}

export default ExpandedRow;